import { get, post, put, getDrawProgressData } from "../../network/apiService";
import { apiUrlHost } from "../servicerOnboarding/servicerOnboarding.action";
export const getLoanInfoForPL = (loanId: string) => {
  const url = `${apiUrlHost}/purchasedloans/aggregate/loanInfo?toorakLoanId=${loanId}`;
  return get(url);
};

export const updatePurchaseFlags = (requestBody: any) => {
  const url = `${apiUrlHost}/drawservice/assetmanagement/document/flag`;
  return put(url, requestBody);
};

export const updateDrawDocsTags = (documentId: string, requestBody: any[]) => {
  const url = `${apiUrlHost}/drawservice/assetmanagement/document/${documentId}/tags`;
  return put(url, requestBody);
};

export const updateDrawDocsAssets = (requestBody: any[], documentId: any) => {
  let url = `${apiUrlHost}/drawservice/assetmanagement/document/assets`;
  if (!requestBody || requestBody.length === 0) {
    url += `?documentId=${documentId}`;
  }
  return put(url, requestBody);
};

export const updateDocsReviewStatus = (requestBody: any) => {
  const url = `${apiUrlHost}/purchasedloans/updateStatus`;
  return post(url, requestBody);
};

export const transferDocs = (documentId: string, requestBody: any) => {
  const url = `${apiUrlHost}/documentdetails/${documentId}/transfer`;
  return put(url, requestBody);
};

export const importDocs = (toorakLoanId: string, requestBody: any) => {
  const url = `${apiUrlHost}/purchasedloans/loan/${toorakLoanId}/import`;
  return put(url, requestBody);
};

export const fetchDrawProgress = async (toorakLoanId: string, requiredDraw: any) => {
  try {
    const data: any = await getDrawProgressData(toorakLoanId, requiredDraw?.getOldestApprovedCompletedDraw?.drawId);
    const lineItems = data?.data?.lineItems || [];
    const drawIdSet = new Set();
    lineItems.forEach((item: any) => {
      if (item.inspectionInfo) {
        Object.keys(item.inspectionInfo).forEach((drawId: string) => drawIdSet.add(drawId));
      }
    });
    const drawIds = Array.from(drawIdSet).sort() as string[];
    const draws = drawIds.map((drawId) => {
      let requiredStatus = false;
      requiredDraw?.allDraws?.forEach((draw: any) => {
        if (Number(draw.drawId) === Number(drawId)) {
           requiredStatus = draw?.budgetReconcileStatus === "Completed" && (draw?.inspectionReviewStatus === "Approved" || draw?.inspectionReviewStatus === "Approved Conditionally");
        }
      });
      return {
        drawId,
        lineItems: lineItems.map((item: any) => {
          const info = requiredStatus && item.inspectionInfo && item.inspectionInfo[drawId as keyof typeof item.inspectionInfo];
          let amount = info && info.latestInspectionBudget != null ? Number(info.latestInspectionBudget) : null;
          let completion = info && info.latestCompletion != null ? Number(info.latestCompletion) : null;
          let formattedAmount = (amount !== null && !isNaN(amount)) ? amount.toFixed(2) : '-';
          let formattedCompletion = (completion !== null && !isNaN(completion)) ? completion.toFixed(2) : '-';
          return {
            item: item.item,
            desc: item.description || item.desc || "",
            amount: formattedAmount,
            completion: formattedCompletion
          };
        })
      };
    });

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          lineItems,
          draws
        });
      }, 2000);
    });
  } catch (err) {
    console.error(err);
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ lineItems: [], draws: [] });
      }, 2000);
    });
  }
};

export const startTaggingDocs = (toorakLoanId: string) => {
  const url = `${apiUrlHost}/purchasedloans/loan/${toorakLoanId}/tag`;
  return put(url);
};
